// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resonator-criteria-selection{height:400px;margin-bottom:12px;overflow-y:auto;border:1px solid rgba(0,0,0,0.1)}.resonator-criteria-selection .criterion-selection-item{font-size:14px !important}\n", ""]);
// Exports
module.exports = exports;
